export default __webpack_public_path__ + "static/media/twitter-logo.d739a66d.svg";